export default "__VITE_ASSET__DVOLjRLU__"